import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'antd'
import PdfReader from '~/components/pdfFileReader'
import Loader from '~/components/loader'
import PropTypes from 'prop-types'

const PdfCarouselModal = ({
	isVisible,
	onClose,
	documents,
	urls,
	loading,
	initialIndex = 0,
	title = 'Visualização de PDF',
}) => {
	const [currentIndex, setCurrentIndex] = useState(initialIndex)

	useEffect(() => {
		setCurrentIndex(initialIndex)
	}, [initialIndex])

	const handleNext = () => {
		setCurrentIndex((prev) => (prev + 1) % documents.length)
	}

	const handlePrev = () => {
		setCurrentIndex((prev) => (prev - 1 + documents.length) % documents.length)
	}

	const currentItem = documents[currentIndex]
	const currentUrl = urls?.[currentItem?.filename || currentItem?.name]

	return (
		<Modal
			title={currentItem?.name || title}
			open={isVisible}
			onCancel={onClose}
			width={900}
			centered
			destroyOnClose
			bodyStyle={{ height: '80vh' }}
			footer={
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<Button onClick={handlePrev} disabled={documents.length <= 1}>
						Anterior
					</Button>
					<Button onClick={handleNext} disabled={documents.length <= 1}>
						Próximo
					</Button>
				</div>
			}>
			{loading ? (
				<div
					style={{
						width: '100%',
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
					<Loader />
				</div>
			) : currentUrl ? (
				<PdfReader url={currentUrl} />
			) : (
				<p>Não foi possível carregar o documento.</p>
			)}
		</Modal>
	)
}

PdfCarouselModal.propTypes = {
	isVisible: PropTypes.bool,
	onClose: PropTypes.func,
	documents: PropTypes.array,
	urls: PropTypes.object,
	loading: PropTypes.bool,
	initialIndex: PropTypes.number,
	title: PropTypes.string,
}

export default PdfCarouselModal
